import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Button, tokens } from '@arvoreeducacao/bonsai-ds'
import { colors, sizes } from 'config/ui'
import { Title } from '@arvoreeducacao/bonsai-ds'

export const ContainerActivity = styled.div`
  margin: 0 auto;
  padding: 0 ${tokens.spacing.horizontalMedium};
  width: 100%;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    padding: 0 ${tokens.spacing.horizontalLarge};
    margin-bottom: ${tokens.spacing.verticalXxlarge};
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    max-width: 1311px;
    padding: 0;
  }
`

export const StyledTitle = styled(Title)`
  margin-top: ${tokens.spacing.verticalXlarge};
  margin-bottom: ${tokens.spacing.verticalXlarge};

  @media (max-width: ${tokens.breakpoints.desktop}px) {
    display: none;
  }
`

export const Header = styled.div`
  background-color: ${tokens.colors.white};
  width: 100%;
  position: sticky;
  z-index: 2;
  height: ${tokens.spacing.verticalXxxlarge};
  left: 0px;
  top: 0px;
  filter: drop-shadow(0px 4px 5px rgba(5, 59, 75, 0.06));
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    padding: 16px 0;
  }
`

export const Section = styled.div`
  margin-bottom: ${tokens.spacing.verticalXlarge};

  h3 {
    margin: 0 0 24px 0;
    color: ${colors.gray9};
    font-size: ${tokens.fontSize.large};
  }
`

export const ContentBooks = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`

export const Book = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (min-width: ${sizes.mediumScreen}px) {
    width: 47%;
  }
`

export const ContCoverInfos = styled(Link)`
  display: flex;
  flex-direction: row;
  margin: 12px 0;
  text-decoration: none;
  cursor: pointer;
`

export const CoverBook = styled.div<{ module?: string }>`
  ${props => `
  width: ${props.module === '4' ? '57px' : '41px'};
  `};
  ${props => `
  height: ${props.module === '4' ? '85px' : '60px'};
  `};
  overflow: hidden;
  border-radius: 3px;
  margin-right: 12px;
  img {
    height: 100%;
  }
`

export const InfoBook = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h5 {
    font-weight: ${tokens.fontWeights.bold};
    color: ${tokens.colors.black6};
    margin-top: 0;
  }

  span {
    font-weight: ${tokens.fontWeights.regular};
    font-size: ${tokens.fontSize.medium};
    color: ${tokens.colors.black5};
  }
`

export const ActivitiesWrapper = styled.div`
  margin-top: ${tokens.spacing.verticalLarge};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 28px;
`

export const ButtonApply = styled(Button)`
  color: ${tokens.colors.white};
`

export const ButtonSave = styled(Button)`
  > div {
    right: 0;

    > div {
      border-top: 2px solid ${tokens.colors.dark5};
    }
  }
`

export const ButtonSend = styled(Button)``

export const ButtonBack = styled(Button)`
  display: none;
  @media (min-width: ${tokens.breakpoints.tablet}px) {
    display: block;
  }
`

export const Wrapper = styled.div`
  padding: 0 ${tokens.spacing.insetMedium};
  margin-right: auto;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    padding: 0 ${tokens.spacing.insetLarge};
  }
`
